import Vue from 'vue';

export const mutations = {
    set_loadTwitchInfo(state, auth) {
        state.twitchUserId = auth.userId;
        state.twitchChannelId = auth.channelId;
        state.twitchAuthToken = auth.token;
        state.twitchClientId = auth.clientId;
    },

    set_token(state, value) {
        Vue.set(state, 'token', value);
        localStorage.setItem('token', value);
    },

    set_viewerSubscriptionStatus(state, value) {
        Vue.set(state, 'viewerSubscriptionStatus', value);
    },

    set_voicemodAccountId(state, value) {
        Vue.set(state, 'voicemodAccountId', value);
        localStorage.setItem('voicemodAccountId', value);
    },

    set_viewerIsLinked(state, value) {
        Vue.set(state, 'viewerIsLinked', value);
    },

    set_vmBitsConnectionButtonIsEnabled(state, value) {
        Vue.set(state, 'vmBitsConnectionButtonIsEnabled', value);
    },

    set_isTwitchLinked(state, value) {
        Vue.set(state, 'isTwitchLinked', value);
    },
};
